/**
 * Created by vaibhav on 31/3/18
 */
module.exports = {
  siteTitle: 'Spin Auto', // Site title.
  siteTitleAlt: 'Business', // Alternative site title for SEO.
  siteLogo: '/logos/logo-512x512.png', // Logo used for SEO and manifest.
  siteUrl: 'https://pensive-wing-1fefae.netlify.com', // Domain of your website without pathPrefix.
  pathPrefix: '/', // Prefixes all links. For cases when deployed to example.github.io/gatsby-starter-business/.
  siteDescription: 'Need a car? Come take one for a spin.', // Website description used for RSS feeds/meta description tag.
  siteRss: '/rss.xml',
  siteFBAppID: '', // FB Application ID for using app insights
  googleTagManagerID: '', // GTM tracking ID.
  disqusShortname: 'gatsby-business-starter', // Disqus shortname.
  userName: 'Matthew Zygowicz',
  userTwitter: 'spinauto',
  userLocation: 'Chicago, Illinois',
  userDescription: '',
  copyright: 'Copyright © Spin Auto 2018. All Rights Reserved.', // Copyright string for the footer of the website and RSS feed.
  themeColor: '#00d1b2', // Used for setting manifest and progress theme colors.
  backgroundColor: '#ffffff', // Used for setting manifest background color.
}



// WEBPACK FOOTER //
// ./meta/config.js